import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const IsAfter = ({ property, onChange, value }) => {  

  const PropertyComponent = resolveComponentForOperator(property.type ? property.type : 'DATE', 'IS_AFTER')

  return (
    <div>
      <PropertyComponent
        property={property}
        onChange={onChange}
        value={value}
        isOperator={true}
      />
    </div>
  )
}

export default IsAfter
